routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.myPaymentsDetail', {
      url: __env.routes.myPaymentsDetail,
      template: `<my-payments-detail sh-ctrl="shCtrl"></my-payments-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.config.js
 **/